import { render, staticRenderFns } from "./PriceDetails.vue?vue&type=template&id=00f76b4e&"
import script from "./PriceDetails.vue?vue&type=script&lang=js&"
export * from "./PriceDetails.vue?vue&type=script&lang=js&"
import style0 from "./PriceDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports